var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9428 5.33464L7.33333 8.94411L5.05719 6.66797L6 5.72516L7.33333 7.05849L10 4.39183L10.9428 5.33464Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6.66797C2 3.35426 4.68629 0.667969 8 0.667969C11.3137 0.667969 14 3.35426 14 6.66797C14 8.35209 13.2354 9.82812 12.1949 11.1793C11.3253 12.3084 10.2124 13.4117 9.10055 14.5139C8.89024 14.7224 8.67998 14.9308 8.4714 15.1394L8 15.6108L7.5286 15.1394C7.32002 14.9308 7.10976 14.7224 6.89945 14.5139C5.78765 13.4117 4.6747 12.3084 3.80515 11.1793C2.76455 9.82812 2 8.35209 2 6.66797Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationFill);
export default __webpack_public_path__ + "static/media/location-fill.4acf8bc0735d9b68b514c7527c99edcc.svg";
export { ForwardRef as ReactComponent };